var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMediaPdfLargeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2998",
    "data-name": "Group 2998",
    transform: "translate(-440 -1280)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2992",
    "data-name": "Group 2992"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_748",
    "data-name": "Rectangle 748",
    width: 40,
    height: 40,
    transform: "translate(440 1280)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2986",
    "data-name": "Group 2986",
    transform: "translate(7.91 7.638)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file",
    transform: "translate(442.772 1280.715)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_723",
    "data-name": "Path 723",
    d: "M14.482,2H6.329A2.329,2.329,0,0,0,4,4.329V22.965a2.329,2.329,0,0,0,2.329,2.329H20.306a2.329,2.329,0,0,0,2.329-2.329V10.153Z",
    transform: "translate(-4 -2)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_724",
    "data-name": "Path 724",
    d: "M13,2v8.153h8.153",
    transform: "translate(-2.518 -2)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("text", {
    id: "PDF",
    transform: "translate(444.909 1298.971)",
    fill: "currentColor",
    fontSize: 7.5,
    fontFamily: "Arial-BoldMT, Arial",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "PDF")))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaPdfLargeIcon);
export default __webpack_public_path__ + "static/media/media-pdf-large-icon.66d0030dabcb0eb3adb8f4441fd604dc.svg";
export { ForwardRef as ReactComponent };